import { User } from "../../../../User/Model/User";

export const isManager = (u: User) => u.grade === 'DISTRIBUTOR' || u.grade === 'AGENCY';

export const assertAdmin = (u: User) => {
  if (u.grade !== 'ADMIN') throw new Error('권한이 없습니다.');
};

export const assertAdminOrManager = (u: User) => {
  if (u.grade !== 'ADMIN' && !isManager(u)) throw new Error('권한이 없습니다.');
};

export const assertIsNotSeller = (u: User) => {
  if (u.grade === 'SELLER') throw new Error('셀러는 권한이 없습니다.');
};

